export const EVENTS = {
    CHANGE: "quantity-change"
};
